import React, { useContext } from "react";
import { TemplateInstanceContext } from "../Providers/TemplateInstanceProvider";

export default () => {
  return useContext(TemplateInstanceContext);
};
